import {useState} from "react";
import { connect } from "react-redux";
import GeneralAssumptions from "./GeneralAssumptions";
import OtherAssumptions from "./OtherAssumptions";
import DistributionsSchedule from "./DistributionsSchedule";
import CashFlowSummary from "./CashFlowSummary";
import ReturnsSummary from "./ReturnsSummary";
import OtherKeyMetrics from "./OtherKeyMetrics";
import BVASelect from "../../../components/BVASelect/BVASelect";
import InvalidBalAlert from "../../../components/BVAAlert/InvalidBalAlert";
import { updateAssumptions, updateDealType } from "../../../store/modules/waterfall/actions";

const GENERAL_ASSUMPTIONS = "GENERAL_ASSUMPTIONS"
const OTHER_ASSUMPTIONS = "OTHER_ASSUMPTIONS"
const DISTRIBUTIONS_SCHEDULE = "DISTRIBUTIONS_SCHEDULE"
const CASH_FLOW_SUMMARY = "CASH_FLOW_SUMMARY"
const RETURNS_SUMMARY = "RETURNS_SUMMARY"
const OTHER_KEY_METRICS = "OTHER_KEY_METRICS"
const AUTO = "AUTO"
const MANUAL = "MANUAL"
const STOCK = "STOCK"
const ASSET = "ASSET"

const acquisitionsExpensesSections = [
  { label: "General Assumptions", value: GENERAL_ASSUMPTIONS },
  { label: "Other Assumptions", value: OTHER_ASSUMPTIONS },
  { label: "Distributions Schedule", value: DISTRIBUTIONS_SCHEDULE },
  { label: "Cash Flow Summary", value: CASH_FLOW_SUMMARY },
  { label: "Returns Summary", value: RETURNS_SUMMARY },
  { label: "Other Key Metrics", value: OTHER_KEY_METRICS },
]

const independence = [
  { label: "Consolidated Mode", value: AUTO },
  { label: "Independent Mode", value: MANUAL }
]

const dealType = [
  { label: "Stock Purchase", value: STOCK },
  { label: "Asset Purchase", value: ASSET }
]

function Waterfall({ assumptions, dispatchUpdateIndependence, dispatchUpdateDealType, onAlertLinkClick }) {
  // State
  const [selectedSection, setSelectedSection] = useState(GENERAL_ASSUMPTIONS);
  const [selectedIndependence, setSelectedIndependence] = useState(assumptions?.independence || AUTO);
  const [selectedDealType, setSelectedDealType] = useState(STOCK);

  const handleIndependenceOnChange = (independence) => {
    dispatchUpdateIndependence(independence);
    setSelectedIndependence(independence);
  };

  const handleDealTypeOnChange = (dealType) => {
    dispatchUpdateDealType(dealType);
    setSelectedDealType(dealType);
  };

  return (
    <div>
      <InvalidBalAlert page={selectedSection} onLinkClick={onAlertLinkClick} />
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <BVASelect
            items={acquisitionsExpensesSections}
            value={selectedSection}
            width="24em"
            placeholder="Select a section"
            onChange={(value) => setSelectedSection(value)}
          />
          <div className="ml-4">
            <BVASelect
              items={independence}
              value={selectedIndependence}
              width="10em"
              placeholder="Select waterfall independence"
              onChange={(value) => handleIndependenceOnChange(value)}
            />
          </div>
        </div>
        <BVASelect
          items={dealType}
          value={selectedDealType}
          width="10em"
          placeholder="Select a deal type"
          onChange={(value) => handleDealTypeOnChange(value)}
        />
      </div>
      <div className="mt-10">
        {selectedSection === GENERAL_ASSUMPTIONS ? (
          <GeneralAssumptions dealType={selectedDealType} />
        ) : null}

        {selectedSection === OTHER_ASSUMPTIONS ? (
          <OtherAssumptions dealType={selectedDealType} />
        ) : null}

        {selectedSection === DISTRIBUTIONS_SCHEDULE ? (
          <DistributionsSchedule dealType={selectedDealType} />
        ) : null}

        {selectedSection === CASH_FLOW_SUMMARY ? (
          <CashFlowSummary dealType={selectedDealType} />
        ) : null}

        {selectedSection === RETURNS_SUMMARY ? (
          <ReturnsSummary dealType={selectedDealType} />
        ) : null}

        {selectedSection === OTHER_KEY_METRICS ? (
          <OtherKeyMetrics dealType={selectedDealType} />
        ) : null}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  assumptions: state.waterfall?.assumptions,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchUpdateIndependence(independence) {
    await dispatch(updateAssumptions("independence", independence));
    await independence === "MANUAL" && dispatch(updateAssumptions("exitProceedsType", "MANUAL"));
  },
  async dispatchUpdateDealType(dealType) {
    await dispatch(updateDealType(dealType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Waterfall);